import { useState, useEffect, useCallback } from "react";
import { getHeaders } from "../utils/api";

const useApiCall = ({
  url,
  method = "GET",
  headers = {},
  body = null,
  navigate = () => {},
  skip = false,
  skipErrorInterceptor = false,
}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const config = {
        method,
        headers: {
          ...getHeaders(),
          ...(skipErrorInterceptor && { "x-skip-error-interceptor": "true" }),
          ...headers,
        },
      };

      if (body !== null) {
        config.body = JSON.stringify(body);
      }
      const response = await fetch(url, config);

      const result = await response.json();
      
      // Only handle auth errors locally, let interceptor handle the rest
      if (!response.ok && skipErrorInterceptor) {
        if (result === "Wrong API format!" || result.startsWith("API Key")) {
          navigate("/");
        }
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      setData(result);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [url, method, headers, body]);

  useEffect(() => {
    if (skip) return;
    fetchData();
  }, []);

  return { data, error, loading };
};

export default useApiCall;
